// Ключи хранения токенов в localStorage
export const ACCESS_TOKEN_KEY = 'auth_access_token';
export const REFRESH_TOKEN_KEY = 'auth_refresh_token';
export const ACCESS_TOKEN_EXPIRES_AT_KEY = 'auth_access_expires_at';
export const REFRESH_TOKEN_EXPIRES_AT_KEY = 'auth_refresh_expires_at';

// Базовый путь для эндпоинтов авторизации (добавляется к API_CONFIG.BASE_URL)
export const AUTH_BASE_PATH = '/api/v1/auth';

// Базовый путь для эндпоинтов конфигурации (добавляется к API_CONFIG.BASE_URL)
export const CONFIG_BASE_PATH = '/api/v1/config';

// Базовый путь для эндпоинтов профиля (добавляется к API_CONFIG.BASE_URL)
export const PROFILE_BASE_PATH = '/api/v1/profile';

// Вспомогательная константа для UX (хранит email при неудачном логине из-за верификации)
export const EMAIL_UNVERIFIED_ADDRESS = 'unverified_email';

/** localStorage prefix for DuelDetail AI Predictions collapsible (suffix: user id or `anon`) */
export const DUEL_AI_PREDICTIONS_OPEN_STORAGE_PREFIX = 'cfpl:duel-ai-predictions-open:';

// Пустой UUID для stub объектов
export const EMPTY_UUID = '00000000-0000-0000-0000-000000000000';

// Stub команда для placeholder объектов
export const STUB_TEAM = { id: EMPTY_UUID, name: '', short_name: '' };

// React Query keys (shared to avoid duplicate API calls)
export const MY_PROFILE_QUERY_KEY = ['profile', 'me'] as const;

// Маппинг позиций игроков (string → number)
export const POSITION_TO_NUMBER: Record<string, number> = {
  'GK': 1,
  'DEF': 2,
  'MID': 3,
  'FWD': 4,
};

/** CDN base URL for static assets (players, shirts, ambassadors, og-cards). Empty env = https://static.crowdfpl.com */
export const CDN_BASE_URL = (
  import.meta.env.VITE_CDN_BASE_URL || 'https://static.crowdfpl.com'
).replace(/\/$/, '');

